import * as React from 'react';

export default function TikTokIcon({
  className,
  viewBox = '0 0 16 16',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 0H8.8v10.9c0 1.3-1 2.3-2.3 2.3s-2.3-1-2.3-2.3 1-2.3 2.3-2.3c.3 0 .5 0 .8.1V6c-.3 0-.5-.1-.8-.1C3.7 5.9 1.3 8.3 1.3 11.2S3.7 16.5 6.5 16.5s5.2-2.3 5.2-5.2V5.5c1.1.8 2.5 1.3 3.9 1.3V4.1c-2.3-.1-4.1-1.9-4.1-4.1Z"
        fill="currentColor"
      />
    </svg>
  );
}
